export default __webpack_public_path__ + "static/media/AMZN_IT_SH_SD.a796386b.svg";